var storage = require('./storage')

exports.hasStorage = storage.hasStorage
exports.setStorage = storage.setStorage
exports.clearStorage = storage.clearStorage
exports.getStorage = storage.getStorage

function init () {
  // If logged out or switch off
  if (/^\/[a-z]{2}\/(auth\/logout|accountmanagement\/switchoff)/i.test(location.pathname)) {
    storage.hasStorage() && storage.clearStorage()
  }
}
document.addEventListener('DOMContentLoaded', init)
